'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$0024 from "./app.data.data_point_types$package$-Document-Number$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentEssentialInfo(kind, number) {
  this.uJ = null;
  this.wD = null;
  this.uJ = kind;
  this.wD = number;
}
export { $c_Lapp_data_AppDocumentEssentialInfo as $c_Lapp_data_AppDocumentEssentialInfo };
$p = $c_Lapp_data_AppDocumentEssentialInfo.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentEssentialInfo;
/** @constructor */
function $h_Lapp_data_AppDocumentEssentialInfo() {
}
export { $h_Lapp_data_AppDocumentEssentialInfo as $h_Lapp_data_AppDocumentEssentialInfo };
$h_Lapp_data_AppDocumentEssentialInfo.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentEssentialInfo)) {
    var x = this.uJ;
    var x$2 = x$0.uJ;
    if ((x === x$2)) {
      return (this.wD === x$0.wD);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "AppDocumentEssentialInfo";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.uJ;
  }
  if ((n === 1)) {
    return this.wD;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "kind";
  }
  if ((n === 1)) {
    return "number";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.hJ = (function(x$1) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$ShowInterpolator$().b5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_StringContext($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.r().C)(["", ": ", ""]))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcats_Show$Shown.r().C)([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$Shown($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$Shown$().aH(this.uJ.hJ(x$1), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_instances_package$string$().bi)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$Shown($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$Shown$().aH(this.wD, $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$().aA()))])));
});
$p.bE2 = (function(x$1) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$ShowInterpolator$().b5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_StringContext($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.r().C)(["", " - ", ""]))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcats_Show$Shown.r().C)([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$Shown($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$Shown$().aH(this.uJ.hJ(x$1), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_instances_package$string$().bi)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$Shown($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_Show$Shown$().aH(this.wD, $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$().aA()))])));
});
function $isArrayOf_Lapp_data_AppDocumentEssentialInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j2)));
}
export { $isArrayOf_Lapp_data_AppDocumentEssentialInfo as $isArrayOf_Lapp_data_AppDocumentEssentialInfo };
var $d_Lapp_data_AppDocumentEssentialInfo = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentEssentialInfo, "app.data.AppDocumentEssentialInfo", ({
  j2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentEssentialInfo as $d_Lapp_data_AppDocumentEssentialInfo };
//# sourceMappingURL=app.data.-App-Document-Essential-Info.js.map
